import type { RegisterOptions } from "../../";
import type { TextAreaProps } from "../../../Inputs/TextArea";
import { TextArea as PrimitiveTextArea } from "../../../Inputs/TextArea";

import { FieldStatus } from "../../../types";

import { ControllerFormField } from "../Controller";

type TextAreaFormFieldProps = (Omit<TextAreaProps, "status" | "label"> & {
  name: string;
  rules?: Omit<
    RegisterOptions,
    "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"
  >;
  defaultValue?: string;
}) &
  (
    | {
        label?: string;
        ariaLabel: string;
      }
    | { label: string; ariaLabel?: string }
  );

export const TextAreaFormField = (props: TextAreaFormFieldProps) => {
  const {
    label,
    name,
    ariaLabel,
    rules,
    required: isRequired,
    defaultValue,
    ...restProps
  } = props;

  return (
    <ControllerFormField
      label={label}
      name={name}
      rules={rules}
      required={isRequired}
      defaultValue={defaultValue}
      render={field => {
        return (
          <PrimitiveTextArea
            {...restProps}
            required={isRequired}
            status={!!field.error ? FieldStatus.ERROR : undefined}
            label={(ariaLabel || label) as string}
            {...field}
          />
        );
      }}
    />
  );
};
